import React from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';

import { DateTimePicker } from './components/DateTimePicker';

import style from './DateTimePickerPopup.scss';

export const DateTimePickerPopup = (props) => {
    const onClose = useOnClose();
    const translate = useTranslations('playtech.mobile.system.scheduledBreaks.DateTimePicker.');

    return (
        <ManagedPopup
            onClose={onClose}
            title={translate('title')}
            classNames={{ header: style.header }}
        >
            <DateTimePicker
                {...props}
                onClose={onClose}
            />
        </ManagedPopup>
    );
};
